import {style} from 'typestyle'
import * as csstips from 'csstips'

export const HomePictureViewWrap = style({
    paddingBottom: 15
})

export const HomePictureView = style({
    marginLeft: 15,
    marginRight: 15
})

export const HomePictureViewInActivity = style({
    border: '4px solid #FF802F',
    background: '#fff',
    borderRadius: 8,
    position: 'relative',
    top: -1,
    marginBottom: 19,
    $nest: {
        '&::before': {
            content: `""`,
            position: 'absolute',
            left: -4,
            top: -4,
            width: 0,
            height: 0,
            borderTop: '10px solid #FF802F',
            borderRight: '10px solid transparent'
        }
    }
})

export const indexFeedDoubleBanner = style({
    ...csstips.flexRoot,
    ...csstips.betweenJustified,
    position: 'relative',
    padding: 15,
    $nest: {
        '&::after': {
            content: `""`,
            position: 'absolute',
            width: 'calc(100% - 30px)',
            height: 1,
            background: '#f0f0f0',
            bottom: 0,
            transform: 'scaleY(0.5)'
        }
    }
})

export const FeedDoubleBannerItem = style({
    width: '48.5%',
    borderRadius: 4,
    $nest: {
        '&:active': {
            opacity: 0.7
        },
        '& img': {
            width: '100%',
            height: '100%',
            borderRadius: 4
        }
    }
})

export const titleName = style({
    fontSize: 20,
    color: '#000000',
    letterSpacing: 0,
    lineHeight: '20px',
    fontWeight: 500,
    // paddingRight: 15,
    // paddingLeft: 15,
    paddingTop: 15,
    paddingBottom: 14
})

export const SingleBanner = style({
    width: '100%',
    $nest: {
        '& img': {
            width: '100%'
        },
        '&:active': {
           opacity: 0.7
        }
    }
})

export const borderWrap = style({
    boxShadow: '0 5px 8px 0 rgba(51,51,51,0.05)',
    borderRadius: 8,
    // marginLeft: 15,
    // marginRight: 15,
    background: '#fff'
})

export const firstAd = style({
    position: 'relative',
    padding: 15,
    $nest: {
        '&::after': {
            content: `" "`,
            position: 'absolute',
            width: 'calc(100% - 30px)',
            height: 1,
            bottom: 0,
            background: '#E6E6E6',
            transform: 'scaleY(0.3)',
            left: 15
        },
        'img': {
            borderRadius: 8
        }
    }
})

export const activityHeader = style({
    backgroundImage: 'url(https://static-1253442168.image.myqcloud.com/picture/12209467_f108f8ea1f4f4ddce4a7588dd878464b.jpg)',
    backgroundSize: '100% 100%',
    width: '74.66vw',
    maxWidth: 358.4,
    height: '9.6vw',
    maxHeight: 46.08,
    marginLeft: 15,
    marginTop: 15
})

export const SpecialLink = style({
    textAlign: 'center',
    $nest: {
        'a': {
            display: 'block',
            textDecoration: 'none',
            fontSize: 14,
            color: 'rgba(153,153,153,1)',
            lineHeight: '20px',
            paddingTop:  13,
            paddingBottom: 15
        },
        '&:active': {
            backgroundColor: '#f8f8f8'
        }
    }
})

export const SpecialLinkArrow = style({
    width: 7,
    marginLeft: 4
})

export const FavourableRollWrap = style({
    background: '#fff',
    border: '4px solid #FF802F',
    borderRadius: 8,
    position: 'relative',
    top: -1,
    $nest: {
        '&::before': {
            content: `""`,
            position: 'absolute',
            left: -4,
            top: -4,
            width: 0,
            height: 0,
            borderTop: '10px solid #FF802F',
            borderRight: '10px solid transparent'
        }
    }
})

export const FavourableRollHeader = style({
    backgroundImage: 'url(https://static-1253442168.image.myqcloud.com/picture/12209467_9a371be4c3ba2d22bd43d66db71350d0.jpg)',
    backgroundSize: '100% 100%',
    height: '12vw',
    marginLeft: 15,
    marginTop: 15,
    maxHeight: 57.6,
    maxWidth: 358.4,
    width: '74.66vw'
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomePictureView/HomePictureView.style.ts